import React from "react";

import { ReferenceInput, AutocompleteInput, DateInput } from "react-admin";

const serviceBookingFilters = [
  <ReferenceInput
    source="customerId"
    reference="Customer"
    sort={{ field: "name", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
    alwaysOn
  >
    <AutocompleteInput optionText="name" emptyText="- alle -" />
  </ReferenceInput>,
  <ReferenceInput
    source="serviceTemplateId"
    reference="ServiceTemplate"
    sort={{ field: "name", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
  >
    <AutocompleteInput optionText="name" emptyText="- alle -" />
  </ReferenceInput>,
  <DateInput source="invoicedUntilLte" alwaysOn defaultValue={null} />,
  <DateInput source="invoicedUntilGt" alwaysOn defaultValue={null} />,
];

export default serviceBookingFilters;
